import { API, API_POST } from "../../config";

export const DeleteFaq = (id,status) => {
  const f = new FormData();
  f.append("que_id", id);
  f.append("status", status);

  return API_POST(API.DeleteFaq, f);
};
